import { defineComponent as _defineComponent } from 'vue'
import { ActionName } from '@/components/ActionsBar/types/ActionBarComponentTypes'
import PromptDialogComponent from '@/components/Dialog/PromptDialogComponent.vue'
import { createLink } from '@/helpers/blob'
import { entityToHtml } from '@/helpers/html'
import { DownloadZipResult } from '@/store/modules/fileManager/fileManagerTypes'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveZipPromtDialogComponent',
  props: {
  isOpened: {
    type: Boolean,
    required: true
  },
  fileSelected: {
    type: Array,
    required: true
  },
  context: {
    type: String,
    default: 'FormSaveAsZip'
  }
},
  emits: ['saveZip', 'closeZip', 'hideSpinner', 'showSpinner'],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n()


// DEFINE PROPS  ======================================================================================================


const openModal = ref(props.isOpened)
const zipFormData = ref()
const saveAsZipDialogFormSchema = ref([
  {
    id: 'name',
    name: 'name',
    type: 'text',
    label: 'Nombre',
    fieldType: 'LexonTextFieldComponent',
    validationRules: 'required|max:255',
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
    'offset-xs': 0,
    'offset-sm': 0,
    'offset-md': 0,
    'offset-lg': 0,
    'offset-xl': 0
  }
])

const saveAsZipText = t('components.file_manager.dialogs.save_as_zip_title')
// COMPOSABLES   ======================================================================================================

// STORE ACTIONS ======================================================================================================

// STORE GETTERS ======================================================================================================

// COMPUTEDS ==========================================================================================================
const zipResult = computed((): DownloadZipResult => {
  // @Getter('getZipResult', { namespace: ModuleNamespaces.FILE_MANAGER }) zipResult: DownloadZipResult
  return {} as DownloadZipResult
})

const blobFile = computed((): Blob => {
  // @Getter('getFile', { namespace: ModuleNamespaces.FILE_MANAGER }) blobFile: Blob
  return {} as Blob
})
// EVENTS =============================================================================================================

// METHODS ============================================================================================================
// *** ZIP
const executeSaveAsZipDialogAction = (actionName: string) => {
  switch (actionName) {
    case ActionName.CLOSE:
      return (openModal.value = false)
    case ActionName.SAVE:
      return saveAsZip()
  }
}

// *** ZIP
const saveAsZip = async () => {
  const name = zipFormData.value.name

  openModal.value = false

  // this.showFileManagerSpinner(this.spinnerText.download)
  // showSpinner

  await downloadZipResult({
    files: JSON.stringify(
      props.fileSelected
      // this.fileManagerInstance.getSelectedFiles().length > 0
      //   ? this.fileManagerInstance.getSelectedFiles()
      //   : this.zipFolderSelected
    ),
    name
  })

  if (zipResult.value && zipResult.value.zip!.length) {
    await downloadAsZip(zipResult.value.zip)

    // this.hideFileManagerSpinner() // emit('hideSpinner')

    let downloadFileName = entityToHtml(name)
    downloadFileName = `${downloadFileName}.zip`
    const blobUrl = URL.createObjectURL(blobFile.value)
    createLink(blobUrl, downloadFileName)
  } else {
    // this.hideFileManagerSpinner() // emit('hideSpinner')
  }
  setDownloadZipResultMessage(zipResult.value)
}

const downloadZipResult = ({}) => {
  // @Action('downloadZipResult', { namespace: ModuleNamespaces.FILE_MANAGER }) downloadZipResult: ({}) => void
}

const downloadAsZip = (zipTmpName: string) => {
  // @Action('downloadAsZip', { namespace: ModuleNamespaces.FILE_MANAGER }) downloadAsZip: (zipTmpName: string) => void
}

// *** ZIP
const setDownloadZipResultMessage = (zipResult: DownloadZipResult | null) => {
  if (!zipResult || !zipResult.zip || zipResult.zip === '') {
    // this.showErrorAlert(fileManagerOpers.DOWNLOAD_AS_ZIP, 0)
    return
  }

  if (zipResult && 0 === zipResult.wrongFiles.length) {
    // this.showSuccessAlert(fileManagerOpers.DOWNLOAD_AS_ZIP, 0)
    return
  }

  if (zipResult && zipResult.wrongFiles.length) {
    let wrongFiles = '<ul class="zip-wrong-files">'
    zipResult.wrongFiles.map((file: string) => {
      wrongFiles += `<li>${file}</li>`
    })
    wrongFiles += '</ul>'

    // this.showDialog({
    //   type: DialogTypes.WARNING,
    //   message: this.$t('components.file_manager.error_messages.download_zip_errors', { wrongFiles }),
    //   hideSecondaryButton: true
    // })
  }
}
// HOOKS =============================================================================================================


return { __sfc: true,t, emit, props, openModal, zipFormData, saveAsZipDialogFormSchema, saveAsZipText, zipResult, blobFile, executeSaveAsZipDialogAction, saveAsZip, downloadZipResult, downloadAsZip, setDownloadZipResultMessage, PromptDialogComponent }
}

})